import * as store from '@attain-apps/fe/web/main/lib/store'

import * as ecModels from '../../../models'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig<
  TTypeParams extends ecModels.TypeParams.Constraint,
>() {
  return {
    getEntity: store.actions.request({
      input: ({
        target = ecModels.Target.DEFAULT,
      }: {
        /**
         * @default ```
         * ```
         * {@link ecModels.Target.DEFAULT}
         */
        readonly target?: ecModels.Target
      }) => ({ target }),
      output: store.actions.Data.asIs<{
        readonly entity?: TTypeParams['entity']
      }>(),
    }),
  } as const satisfies store.actions.Config.Constraint<State<TTypeParams>>
}
